import { GET_INCUBATOR_REWARDS } from '../mutation-types'

const state = { all: [] }

const mutations = {
  [GET_INCUBATOR_REWARDS] (state, incubatorRewards) {
    state.all = incubatorRewards
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/incubatorRewards.js